// extracted by css-extract-rspack-plugin
var _1 = "WLyWd7DFTyUcgTRvi45ldg--";
var _2 = "DMuQDHl1vQ74W-BOTZrHag--";
var _3 = "bhF7l3ZVHd0iflctfTk-tw--";
var _4 = "rGZSkEToS3wv995S220msA--";
var _5 = "tJ--Qa0SCRzGeJtCb3kmIw--";
export { _1 as "bottom16", _2 as "cancelLegacyOutwardMargin", _3 as "left16", _4 as "right16", _5 as "top16" }
